const financingOf = [
  {
    id: "financingOf",
    isInline: true,
    title: {
      es: "Con la financiación de",
      cat: "Amb el finançament de",
    },
    items: [
      {
        title:
          "Conselleria de Fons Europeus, Universitat i Cultura - Govern de les Illes Balears",
        image: "financing-of-goib.png",
        size: 2,
        original: true,
        link: {
          cat: "https://www.caib.es/sites/manualdidentitatcorporativa/ca/conselleria_de_fons_europeus_universitat_i_cultura/",
          es: "https://www.caib.es/sites/manualdidentitatcorporativa/ca/conselleria_de_fons_europeus_universitat_i_cultura/",
        },
      },
    ],
  },
];

export default financingOf;
